export const product = {
  product: "Product",
  allProducts: "All Products",
  myProducts: "My Products",
  assetManagement: "Asset Management",
  addProduct: "Add Product",
  addEditProduct: "Add/Edit Product",
  saveProduct: "Save Product",
  productProperties: "Product Properties",
  productCategories: "Product Categories",
  propertyValue: "Property Value",
  publicName: "Public Name",
  name: "Name",
  tradeName: "Trade Name",
  vat: "VAT",
  url: "URL",
  productName: "Product Name",
  description: "Description",
  cost: "Cost",
  numerical: "Numerical",
  products: "Products",
  productDetails: "Product Details",
  manufacturer: "Manufacturer",
  yearOfManufacturing: "Year of Manufacturing",
  uponRequest: "Upon Request",
  priceUponRequest: "Price Upon Request",
  noProducts: "No products",
  postedBy: "Posted By",
  createdAt: "Created At",
  selectSubCategory: "Select Sub-Category",
  selectExtraCategory: "Select Extra Category",
  price: "Price",
  isUsed: "Is Used",
  condition: "Condition",
  contactPerson: "Contact Person",
  person: "Person",
  contactEmail: "Contact Email",
  email: "Email",
  contactPhoneNumber: "Contact Phone Number",
  phoneNumber: "Phone Number",
  paymentInfo: "Payment Info",
  updateProduct: "Update Product",
  updatedAt: "Updated At",
  inventory: "Inventory",
  quantity: "Quantity",
  addInventory: "Add Inventory",
  notes: "Notes",
  myProduct: "My Product",
  addToCart: "Add to Cart",
  createdBy: "From",
  me: "Me",
  filters: "Filters",
  filter: "Filter",
  clear: "Clear",
  details: "Details",
  withImages: "With Images",
  author: "Author",
  syncWithExternalMarketplaces: "Sync with External Marketplaces",
  somethingWentWrong: "Something went wrong",
  pleaseContactTheAdministrator: "Please contact the administrator",
  perPage: "per page",
  fillThePropertyFirst: "Fill the property first",
  onlyDeletesEmptyProperty: "Only deletes empty property",
  basicInformation: "Basic Information",
  secondaryInformation: "Secondary Information",
  generalOrderInfo: "General Order Info",
  linePerformance: "Production line & Performance",
  all: "All",
  forSale: "For Sale",
  primaryEquipment: "Primary Equipment",
  secondaryEquipment: "Secondary Equipment",
  currentOwner: "Current Owner",
  serialNumber: "Serial Number",
  equipmentType: "Equipment Type",
  installationRequirements: "Installation Requirements",
  processingInfo: "Processing Info",
  notForSale: "Not For Sale",
  thirdPartyServices: "Third Party Services",
  thirdParty: "Third Party",
  spareParts: "Spare Parts",
  incumbent: "Incumbent",
  productCapabilities: "Product Capabilities",
  equipmentCapabilities: "Equipment Capabilities",
  deleteProduct: "Delete Product",
  deleteProductWarning: "Are you sure you want to delete this product?",
  anErrorOccurred: "An error occurred",
  errorFetchingProducts: "Error fetching products",
  lastRemanufacturer: "Last Re-Manufacturer",
  yearOfLastRemanufacturing: "Year of Last Re-Manufacturing",
  tags: "Tags",
  tag: "Tag",
  deleteThisProduct: "Delete this product",
  requiredWorkerSkills: "Required Worker Skills",
  existingWorkerSkills: "Existing Worker Skills",
  workerSkills: "Worker Skills",
  factoryOwnerRequirements: "Factory Owner Requirements",
  environmentalProperties: "Environmental Properties",
  connectionCapabilities: "Connection Capabilities",
  byAuction: "By Auction",
  visitWebsite: "Visit Website",
  manufacturedYear: "Manufactured Year",
  dataset: "Dataset",
  datasets: "Datasets",
  datasetManagement: "Dataset Management",
  allDatasets: "All Datasets",
  myDatasets: "My Datasets",
  noDatasets: "No datasets",
  datasetName: "Dataset Name",
  dataType: "Data Type",
  industrySector: "Industry Sector",
  format: "Format",
  datasetDetails: "Dataset Details",
  dataCollectionMethod: "Data Collection Method",
  associatedResearch: "Associated Research",
  systemicInnovation: "Systemic Innovation",
  systemicInnovations: "Systemic Innovations",
  associatedSystemicInnovations: "Associated Systemic Innovations",
  mySystemicInnovations: "My Systemic Innovations",
  allSystemicInnovations: "All Systemic Innovations",
  addSystemicInnovation: "Add Systemic Innovation",
  implementationLevel: "Implementation Level",
  licenseType: "License Type",
  benefits: "Benefits",
  addEditDataset: "Add/Edit Dataset",
  addEditSystemicInnovation: "Add/Edit Systemic Innovation",
  systemicInnovationDetails: "Systemic Innovation Details",
  regulatoryCompliance: "Regulatory Compliance",
  competitionAnalysis: "Competition Analysis",
  valueProposition: "Value Proposition",
  problemStatement: "Problem Statement",
  deleteDataset: "Delete Dataset",
  contactPhone: "Contact Phone",
  shortDescription: "Short Description",
  fullDescription: "Full Description",
  dataProvider: "Data Provider",
  size: "Size",
  updateFrequency: "Update Frequency",
  accessLevel: "Access Level",
  geographicalScope: "Geographical Scope",
  timePeriodCovered: "Time Period Covered",
  variablesFeatures: "Variables & Features",
  compliancePlusStandards: "Compliance & Standards",
  associatedResearchPublications: "Associated Research & Publications",
  pricingInfo: "Pricing Information",
  contactPersonOrganization: "Contact Person / Organization",
  lastUpdated: "Last Updated",
  insertedByUser: "Inserted by User",
  apiUrl: "API URL",
  leadingOrganizations: "Leading Organizations",
  technologyStack: "Technology Stack",
  objectives: "Objectives",
  benefitsAndExpectedOutcomes: "Benefits & Expected Outcomes",
  measurableImpact: "Measurable Impact",
  pilotLocations: "Pilot Locations",
  caseStudies: "Case Studies",
  regulatoryComplianceAndEthicsConsiderations:
    "Regulatory Compliance & Ethics Considerations",
  publicationsReportsAndMedia: "Publications, Reports & Media",
  relatedDatasets: "Related Datasets",
  pricingModel: "Pricing Model",
  noSystemicInnovations: "No Systemic Innovations",
  addDataset: "Add Dataset",
  informationAboutBusinessModels: "Information about Business Models",
  businessModels: "Business Models",
  processingAndInstallation: "Processing & Installation",
  basePlateWidth: "Base Plate Width",
  basePlateLength: "Base Plate Length",
  basePlateMountingInfo: "Base Plate Mounting Info",
  mountingPosition: "Mounting Position",
  foundationRequirements: "Foundation Requirements",
  ambientTempMin: "Ambient Temp Min",
  ambientTempMax: "Ambient Temp Max",
  pressureAirSupply: "Pressure Air Supply",
  pressureAirSpecs: "Pressure Air Specs",
  exhaustSystem: "Exhaust System",
  exhaustSystemSpecs: "Exhaust System Specs",
  powerConnection: "Power Connection",
  powerConnectionSpecs: "Power Connection Specs",
  waterSupply: "Water Supply",
  waterSupplySpecs: "Water Supply Specs",
  gasSupply: "Gas Supply",
  gasSupplySpecs: "Gas Supply Specs",
  energyConsumption: "Energy Consumption",
};
